export var serializeGroups = function serializeGroups(groups) {
  return groups.map(function (_ref) {
    var property = _ref.property;
    return property;
  });
};